import { canAccessRoute, getCurrentRoute } from '../routing/routes';
import { useAuth } from '../state/AuthProvider';
import { AdminView } from '../views/AdminView';
import { CalendarView } from '../views/CalendarView';
import { GamesView } from '../views/GamesView';
import { InternalView } from '../views/InternalView';
import { LoginView } from '../views/LoginView';
import { ProfileView } from '../views/ProfileView';
import { RegisterView } from '../views/RegisterView';
import { ProtectedMessage } from './ProtectedMessage';
import {CalendarPrintHalfYearView} from "../calendar/CalendarPrintHalfYearView";
import {CalendarAgendaView} from "../calendar/CalendarAgendaView";

export function PwaContent() {
    const authContext = useAuth();
    const currentRoute = getCurrentRoute();

    if (authContext.loading) {
        return <Shell title="Lade Mitgliederbereich" subtitle="Der Loginstatus wird geprüft."><p className="text-gray-600">Bitte kurz warten ...</p></Shell>;
    }

    if (!canAccessRoute(currentRoute, authContext)) {
        return <ProtectedMessage route={currentRoute} />;
    }

    if (currentRoute.key === 'login') return <LoginView />;
    if (currentRoute.key === 'register') return <RegisterView />;
    if (currentRoute.key === 'kalender_print') { return <CalendarPrintHalfYearView />; }
    if (currentRoute.key === 'kalender') { return <CalendarAgendaView />; }
    if (currentRoute.key === 'games') return <GamesView />;
    if (currentRoute.key === 'internal') return <InternalView />;
    if (currentRoute.key === 'profile') return <ProfileView />;
    if (currentRoute.key === 'admin') return <AdminView />;

    return <CalendarView />;
}

export function Shell({ title, subtitle, children }: { title: string; subtitle: string; children: React.ReactNode }) {
    return (
        <>
            <h1 className="">{title}</h1>
            <p className="">{subtitle}</p>
            <div className="">{children}</div>
        </>
    );
}
